module.exports = __webpack_public_path__ + "img/cir-close.ff7a315b.svg";